<template>
    <div class="flex bg-gray-50">
        <div class="flex flex-wrap  items-baseline gap-y-5 gap-x-3 justify-center">
            <template v-for="(item, index) in props.items" :key="index">
            <BookCardVue
                :item="item"
                :mode="'default'"
                :show-book-name="true"
                :show-description="false"
                @to_basket="emit('to_basket', $event)"
                :loading="props.loading"
                :card-target="'_self'"
            >
            </BookCardVue>
        </template>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { type BookItem } from '@/types/book_item'
import BookCardVue from '@/components/BookCard.vue';

const props = defineProps<{
  items: BookItem[],
  loading?: boolean
}>()

const emit = defineEmits<{
  (e: 'to_basket', item: BookItem): void
}>()

</script>
